import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager'
import UserNotification from '@/Manager/Notification/User.manager'
import ChannelNotification from '@/Manager/Notification/Channel.manager'
import KeyboardManager from '@/Manager/keyboard.manager'

import Global from '@/scripts/Global'
import ChannelApi from '@/scripts/api/channel.api'
import FolderApi from '@/scripts/api/folder.api'
import LicenseApi from '@/scripts/api/license.api'
import LicenseDetails from '@/components/RightSidebar/ChannelSettings/LicenseDetails/LicenseDetails.vue';
import VueSignals from '@/scripts/VueSignals';

import config from '@/scripts/config'

export default {
    name: 'ChannelSettings',
    data() {
        return {
            rightSidebarTheme: 'channel_settings',
            activeChannelDoc: SessionManager.getActiveChannel(),
            editPurposeFlag: false,
            newPurpose: String,
            showModal: false,
            mainSpinner: false,
            nodes: Array,
            // licenses: Array,
            organisationUsers: SessionManager.getUsers(),
            hasAdminRights: this.$parent.user_rights,
            nodeErrorMessage: false,
            errorMessage: '',
            showOptionsMenu: false,
            channel_options_highlight: false,
            licenseDoc: null,
            publicURL: '',
            copiedURL: '',
            subfolder: false,
            parentDocs: [],
            isCreator: false,
            defaultUserImage: config.DEFAULT_USER_IMAGE,
        }
    },
    components: {
        LicenseDetails,
    },
    created() {
        serverBus.$on(VueSignals.ACTIVE_CHANNEL_PARENT_DOCS, (parent_docs) => {
            if (parent_docs.length > 0) {
                this.subfolder = true
                this.parentDocs = parent_docs
            }
        })
    },
    mounted() {

        serverBus.$on(VueSignals.HIDE_CONTEXT_MENU, (success) => {
            this.showOptionsMenu = false
        })


        document.onmouseup = function(e) {
            if (!e.target.classList.contains('settings-icon')) {
                Global.globalValue(VueSignals.CLOSE_OPTIONS_MENU, true)
            }
        }

        serverBus.$on(VueSignals.CLEAR_COPPIED, (success) => {
            this.copiedURL = ''
        })

        serverBus.$on(VueSignals.CLOSE_OPTIONS_MENU, (success) => {
            this.showOptionsMenu = false
        })


        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL_NAME, (success) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (ch_id) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()
            this.licenseDoc = null
            this.errorMessage = ''
            this.publicURL = window.location.host + "/contact?c=" + this.activeChannelDoc.channel_id + "&n=" + this.activeChannelDoc.channel_name
            this.subfolder = false
            this.parentDocs = []
            this.isCreator = (this.activeChannelDoc.creator_id == SessionManager.getLoggedInUserId())
        })

        serverBus.$on(VueSignals.CHANNEL_DETAILS_OVERRIDED, (ch_id) => {
            this.LoadSettings()
        })



        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.rightSidebarTheme = theme
        })


        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (ch_id) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()
            this.organisationUsers = []
            this.licenseDoc = null
            this.errorMessage = ''
            this.subfolder = false
            this.parentDocs = []
        })


        serverBus.$on(VueSignals.EDIT_CHANNEL, (new_purpose) => {
            this.newPurpose = new_purpose
            this.editChannel()
        })

        serverBus.$on(VueSignals.LEAVE_CHANNEL_CONFIRMATION, (channel_id) => {
            if (this.activeChannelDoc.channel_id == channel_id) {
                this.leaveConfirmation()
            }
        })

        serverBus.$on(VueSignals.DELETE_CHANNEL_CONFIRMATION, (data) => {
            if (this.activeChannelDoc.channel_id == data.channel_id) {
                this.deleteConfirmation(data.type)
            }
        })


        serverBus.$on(VueSignals.CHANNEL_OPTIONS_HIGHLIGHT, (channel_options_highlight) => {
            this.activeChannelDoc_options_highlight = true
            setTimeout(function() {
                Global.globalValue(VueSignals.REMOVE_CHANNEL_OPTIONS_HIGHLIGHT, false);
            }, 2000)
        })

        serverBus.$on(VueSignals.REMOVE_CHANNEL_OPTIONS_HIGHLIGHT, (success) => {
            this.activeChannelDoc_options_highlight = false
        })

        // serverBus.$on(VueSignals.REMOVE_CHANNEL_LICENSE, (data) => {
        //     if (data.event == VueSignals.REMOVE_CHANNEL_LICENSE &&
        //         this.activeChannelDoc.channel_id == data.channel_id) {
        //         for (let i = 0; i < this.licenses.length; i++) {
        //             if (this.licenses[i].cust_order_cp_id == data.removed_license_id) {
        //                 this.licenses.splice(i, 1)
        //                 break
        //             }
        //         }
        //     }
        // })
        //
        // serverBus.$on(VueSignals.ADD_CHANNEL_LICENSE, (data) => {
        //     if (data.event == VueSignals.ADD_CHANNEL_LICENSE &&
        //         this.activeChannelDoc.channel_id == data.channel_id) {
        //         this.licenses.push(data.assigned_license)
        //     }
        // })

    },
    methods: {
        LoadSettings() {
            if (this.activeChannelDoc.type != 'invitation') {
                let channelUserIds = SessionManager.getActiveChannel().user_ids
                let arr = []
                this.activeChannelDoc = SessionManager.getActiveChannel()
                this.hasAdminRights = SessionManager.getActiveChannel().admin
                for (let i = 0; i < this.organisationUsers.length; i++) {
                    if (typeof channelUserIds != 'undefined' && !channelUserIds.includes(this.organisationUsers[i].user_id)) {
                        arr.push(this.organisationUsers[i])
                    } else {
                        arr.push(this.organisationUsers[i])
                    }

                }
            }


            /**
             * get Nodes of channel
             */
            ChannelApi.getNodes(this.activeChannelDoc.channel_id).then(res => {
                if (typeof res.data != 'undefined' && typeof res.data.nodes != 'undefined' && res.data.nodes.length > 0) {
                    this.nodeErrorMessage = false
                    this.nodes = res.data.nodes
                } else {
                    this.nodes = []
                    this.nodeErrorMessage = true
                }
            })
            /**
             * get License assigned for channel
             */
            // LicenseApi.List(this.activeChannelDoc.channel_id).then(res => {
            //     if (res.data.result) {
            //         this.licenses = res.data.licenses
            //     }
            // })
        },
        getUserDetails(user_id) {
            return SessionManager.getUser(user_id);
        },
        editPurpose() {
            KeyboardManager.disableChatMode()
            this.editPurposeFlag = true
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'purpose_edit')
        },
        editChannel() {
            if (this.activeChannelDoc.type == 'channel') {
                this.mainSpinner = true
                ChannelApi.editChannel(this.activeChannelDoc.channel_id, this.newPurpose).then(res => {
                    if (res.data.result) {
                        ChannelNotification.ChannelPurposeEdit(this.activeChannelDoc.channel_id,
                            this.activeChannelDoc.channel_purpose,
                            this.activeChannelDoc.user_ids)
                        this.activeChannelDoc.channel_purpose = this.newPurpose
                        SessionManager.UpdateChannel(this.activeChannelDoc.channel_id, {
                            "channel_purpose": this.newPurpose
                        })
                        this.editPurposeFlag = false
                        this.mainSpinner = false
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                    } else {
                        if (res.data.reason == "user_has_no_access") {
                            this.errorMessage = "You dont have the rights to edit it"
                        }
                        this.mainSpinner = false
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                    }
                })
            }
        },
        leaveChannel() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'leave_channel')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "channel_name": this.activeChannelDoc.channel_name,
                "channel_id": this.activeChannelDoc.channel_id
            })
        },
        leaveConfirmation() {
            this.mainSpinner = true
            KeyboardManager.disableChatMode()
            ChannelApi.leaveActiveChannel(SessionManager.getActiveChannel().channel_id).then(res => {
                if (res.data.result) {
                    this.mainSpinner = false

                    UserNotification.UserLeft(SessionManager.getActiveChannelId(), SessionManager.GetActiveChannelUserIds())
                    SessionManager.removeChannel(SessionManager.getActiveChannelId())
                    // Global.globalValue(VueSignals.REMOVE_CHANNEL, SessionManager.getActiveChannelId())
                    SessionManager.setFirstChannelActive()
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                } else {
                    if (res.data.reason == "last_user_can_not_leave") {
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                        this.mainSpinner = false
                        this.errorMessage = "Last user in the channel can not leave, if you want you have to delete the channel"
                    }
                }
            })
        },
        deleteChannel() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'delete_channel')
            let channel = SessionManager.getChannel(this.activeChannelDoc.channel_id) // to get channel name forr direct
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "channel_name": channel.channel_name,
                "channel_id": this.activeChannelDoc.channel_id,
                "type": 'channel'
            })
        },
        deleteFolder() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'delete_channel')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "channel_name": this.activeChannelDoc.channel_name,
                "channel_id": this.activeChannelDoc.channel_id,
                "type": 'folder'
            })
        },
        deleteConfirmation(type) {
            this.mainSpinner = true;
            if (type == 'channel') {
                ChannelApi.delete(SessionManager.getActiveChannel().channel_id).then(res => {
                    if (res.data.result) {
                        this.mainSpinner = false
                        ChannelNotification.ChannelDelete(SessionManager.getActiveChannelId(), SessionManager.GetActiveChannelUserIds())
                        Global.globalValue(VueSignals.REMOVE_CHANNEL, SessionManager.getActiveChannelId())
                    }
                })
            }

            if (type == 'folder') {
                FolderApi.deleteFF(SessionManager.getActiveChannel().channel_id).then(res => {
                    if (res.data.result) {
                        this.mainSpinner = false;
                        ChannelNotification.ChannelDelete(SessionManager.getActiveChannelId(), SessionManager.GetActiveChannelUserIds())
                        Global.globalValue(VueSignals.REMOVE_CHANNEL, SessionManager.getActiveChannelId())
                    }
                })
            }

            this.mainSpinner = false
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
        },
        assignLicense() {
            Global.globalValue(VueSignals.OVERLAY_TYPE, 'assign_license')
            Global.globalValue(VueSignals.SHOW_MODAL, true)
        },
        // showLicenseDetails(cust_order_cp_id) {
        //     for (let i = 0; i < this.licenses.length; i++) {
        //         if (this.licenses[i].cust_order_cp_id == cust_order_cp_id) {
        //             this.licenseDoc = this.licenses[i]
        //             break
        //         }
        //     }
        // },
        unAssignLicense(cust_order_cp_id, license_name) {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'remove_license')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "cust_order_cp_id": cust_order_cp_id,
                'license_name': license_name
            })
        },
        ChangePublic() {
            this.activeChannelDoc.public = !this.activeChannelDoc.public
            ChannelApi.UpdatePublic(this.activeChannelDoc.channel_id, this.activeChannelDoc.public)
        },
        Copy(url) {
            try {
                document.getElementById("channel_public_url").select()
                document.execCommand('copy')
                this.copiedURL = url
                setTimeout(function() {
                    Global.globalValue(VueSignals.CLEAR_COPPIED, true)
                }, 2000)
            } catch (err) {
                console.log(err)
            }
        },
        loadChannelPicture(e) {
            let files = e.target.files;
            if (files.length > 0) {
                let selectedFile = files[0];
                if (files[0].type.includes('image')) {
                    let url = window.URL.createObjectURL(selectedFile);
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.UPLOAD_CHANNEL_PICTURE)
                    Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {'url': url, 'type': selectedFile.type})
                }
            }
        },
        getChannelPicture() {
            return Global.getChannelPicture(this.activeChannelDoc);
        },
        openMediaModal() {
            let imgUrl = this.getChannelPicture();
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true);
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.MEDIA_MODAL);
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {'url': imgUrl});
        }
    }
}
